
export const ContractErrorType = 'CONTRACT_ERROR';

export class ContractError extends Error {
  constructor(message) {
    super(message);
    this.type = ContractErrorType;
  }
}
